import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import CashOrder from '@/factory/cash_order'
import Vue from 'vue'

export default {
  state: {
    paymentRequests: [],
    paymentRequestCounter: 0,
    paymentRequestFilters: [],

    cashOrders: [],
    cashCounter: 0,
    cashSummary: null,
    cashOrder: {},
    orderHistory: [],
    cleanCashOrder: CashOrder.create(),

    orders: [],
    certifications: [],
    salary: {},
    salaries: [],

    orderFilters: [],
    orderStatuses: [],
    paymentStatuses: [],
    paymentTypes_get: [],
    ordersCounter: 0,
    ordersSummary: null,
    certificateFilters: [],
    certificateListFilters: [],
    cashOrdersFilters: [],

    paymentTypes: Vue.config.PAYMENT_TYPES_OBJECT,
    orderItemTypes: Vue.config.ORDER_ITEM_TYPE_TITLES,
    orderDoneStatuses: Vue.config.ORDER_DONE_STATUSES,

    operations: [],
    basis: [],
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
